const $inject = ['$scope', '$routeParams', 'Upload', 'dataService', 'authService'];

function dateTimeString(int){
  if(String(int).length === 1) return '0' + int;

  return String(int);
}

const lbaFileUploaderCtrl = function ($scope, $routeParams, Upload, dataService, authService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  
  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.blobUrl = blobUrl;
  vm.progressPercentage = 0;
  vm.uploadSuccess = false;
  vm.uploadFailure = false;
  vm.authService = authService;
  vm.isEnabled = true;
  
  if(vm.settings.isEnabledMethod){
    vm.isEnabled = eval(vm.settings.isEnabledMethod);
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  vm.upload = function (file) {
    vm.uploadFailure = false;

    vm.filename = '';

    if (!file) {
      vm.uploadFailure = true;
      return false;
    }

    let fileExtension = file.name.substr(file.name.lastIndexOf('.'));
    let fileName = '';
    let fileNameDate = new Date();
    if(vm.settings.rawFileWithDate){
      fileName = dateTimeString( fileNameDate.getFullYear() );
      fileName += dateTimeString( fileNameDate.getMonth() + 1);
      fileName += dateTimeString( fileNameDate.getDate() ) + '_';
      fileName += dateTimeString( fileNameDate.getHours() );
      fileName += dateTimeString( fileNameDate.getMinutes() );
      fileName += dateTimeString( fileNameDate.getSeconds() )
       + '_' + file.name.substr(0,file.name.lastIndexOf('.'));
      fileName = fileName.replace(/[^\w\s _]/g,'');
    }else if(vm.settings.fileNameFormat){
      

      fileName = dateTimeString( fileNameDate.getFullYear() );
      fileName += dateTimeString( fileNameDate.getMonth() + 1);
      fileName += dateTimeString( fileNameDate.getDate() ) + '_';
      fileName += dateTimeString( fileNameDate.getHours() );
      fileName += dateTimeString( fileNameDate.getMinutes() );

    } else {
      fileName = new Date() + '';
      fileName = fileName.replace(/[^\/\d]/g, '');
    }

    if(vm.settings.fileNamePrefixProperty){
      fileName = dataService.data.activeItem[vm.settings.fileNamePrefixProperty] + '_' + fileName;
    }

    if (vm.settings.fileNamePrefix) {
      fileName = vm.settings.fileNamePrefix + '_' + fileName;
    }

    if(vm.settings.fileNameSuffix){
      fileName = fileName + vm.settings.fileNameSuffix;
    }

    fileName += fileExtension;

    Upload.upload({
      url: `${endPointUrl}/api/Upload/${vm.settings.fileContainer}?filename=${fileName}`,
      data: {file: file}
    }).then(function (resp) {
      vm.uploadSuccess = true;
      if(!vm.settings.excludeFromPost){
        vm.data = resp.data;
      } else {
        vm.filename = resp.data;
      }
    }, function (resp) {
      vm.uploadSuccess = false;
      vm.uploadFailure = true;
      console.log('Error status: ' + resp.status);
    }, function (evt) {
      vm.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    });
  };
};

lbaFileUploaderCtrl.$inject = $inject;

export default lbaFileUploaderCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaFileUploader/lbaFileUploaderCtrl.js